import React, { useState, createRef } from 'react';
import {
    Form,
    FormGroup,
    Label,
    Col,
    Input,
} from "reactstrap";
import "./Login.css"
import { useNavigate } from 'react-router-dom';
import swal from 'sweetalert';
import {
    Box,
    Button,
    Container,
    TextField,
    Typography,
    Link,
    Backdrop,
    CircularProgress
  } from "@mui/material";
import { useForgotPassword } from "../../hooks/useAuth";

const ForgotPassword = () => {
    const [newUserPassword, setNewUserPassword] = useState('');
    const [vNewUserPassword, setVNewUserPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [errortext, setErrortext] = useState('');
    const forgotPassword = useForgotPassword();

    const passwordInputRef = createRef();
    const navigate = useNavigate();

    const handleSubmitButton = () => {
        setErrortext('');

        if (!newUserPassword) {
            swal({
                text: 'Please fill In Your New Password',
                icon: "error"
            });
            return;
        }

        if (!vNewUserPassword) {
            swal({
                text: 'Please Verify Your New Password',
                icon: "error"
            });
            return;
        }

        if (vNewUserPassword !== newUserPassword) {
            swal({
                text: 'Passwords do not match, please try again.',
                icon: "error"
            });
            return;
        }

        const urlString = window.location.href;
        const url = new URL(urlString);
        const token = url.searchParams.get("token");

        setLoading(true);
        let dataToSend = { ConfirmToken: token, NewPassword: newUserPassword };
        forgotPassword.mutate({ payload: dataToSend, navigate });
    };

    return (
        <div>
            <Form className='registerForm' onSubmit={handleSubmitButton}>
                <h1 className='noticeHeader'>
                <Typography color="textPrimary" variant="h2">Forgot Password</Typography>
                </h1>
                <Col>
                    <TextField
                            fullWidth
                            label="New Password"
                            margin="normal"
                            name="password"
                            onChange={(event) => setNewUserPassword(event.target.value)}
                            type="password"
                            value={newUserPassword}
                            variant="outlined"/>
                </Col>
                <Col>
                    <TextField
                            fullWidth
                            label="Verify New Password"
                            margin="normal"
                            name="password"
                            onChange={(event) => setVNewUserPassword(event.target.value)}
                            type="password"
                            value={vNewUserPassword}
                            variant="outlined"/>
                </Col>
                <FormGroup row>
                    <Button className="registerBtn" onClick={handleSubmitButton}>Submit</Button>
                </FormGroup>
            </Form>
        </div>
    );
};

export default ForgotPassword;